import { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';
import { initGA, logPageView } from './analytics';

export const hasIubendaConsent = () =>
    document.cookie
        .split(';')
        .some((c) => c.trim().startsWith('_iub_cs'));

declare global {
    interface Window {
        iubenda?: { consent?: { triggerPageView?: () => void } };
    }
}

export default function RouteTracking() {
    const { pathname } = useLocation();
    const gaReady = useRef(false);
    useEffect(() => {
        window.iubenda?.consent?.triggerPageView?.();
        if (!hasIubendaConsent()) return;

        if (!gaReady.current) {
            const initGoogleAnalytics = initGA();
            gaReady.current = Boolean(initGoogleAnalytics);
        }

        if (gaReady.current) {
            logPageView(pathname);
        }
    }, [pathname]);

    return null;
}
